/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_5_PickInputs */

const en_pc_alt_pick_5_pick = /** @type {(inputs: Pc_Alt_Pick_5_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft Online, or the PDFCraftTool/pdfcraft toolkit if you prefer many single-purpose tools on one site.`)
};

const zh_pc_alt_pick_5_pick = /** @type {(inputs: Pc_Alt_Pick_5_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 PdfCraft 在线版；如果更喜欢在一个网站上使用许多单项工具，可以用 PDFCraftTool/pdfcraft 工具集。`)
};

/**
* | output |
* | --- |
* | "PdfCraft Online, or the PDFCraftTool/pdfcraft toolkit if you prefer many single-purpose tools on one site." |
*
* @param {Pc_Alt_Pick_5_PickInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_5_pick = /** @type {((inputs?: Pc_Alt_Pick_5_PickInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_5_PickInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_5_pick(inputs)
	return zh_pc_alt_pick_5_pick(inputs)
});
export { pc_alt_pick_5_pick as "pc.alt.pick.5.pick" }